import {useEffect, useRef, useState} from 'react';
import {VEDIO_PLAYER_URL} from '../../../services/urls';

type ProgramPlayerProps = {
  courseList?: any | null;
  cid?: string;
  fullScreen?: boolean;
  goBackUrl?: string;
  courseUpdate?: any;
  playVideo: any;
  updateCompaletedStatus?: () => void;
  mid?: string;
  updateCompletedCourse?: any;
  program_id?:string;
  program_name?:string;
};
export const  FullScreenPlayer =(Props: ProgramPlayerProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const {cid, fullScreen} = Props;
  const [showFullScreen, setShowFullScreen] = useState(false);
  const token = localStorage.getItem('access_token');
  const [pcid] = useState(Props.cid);

  useEffect(() => {
    let url = `${VEDIO_PLAYER_URL}${cid}&access_token=${token}`;
    if (Props.mid) {
      url = url + `&module_id=${Props.mid}`;
    }
    if (Props.program_id) {
      url = url + `&program_id=${Props.program_id}`;
    }
    
    if (Props.program_name) {
      url = url + `&program_name=${Props.program_name}`;
    }
    
    if (url && iframeRef?.current) {
      iframeRef.current.src = url;
      iframeRef.current.setAttribute('allowTransparency', 'true');
      iframeRef.current.setAttribute('allowFullScreen', 'true');
    }
    const closePlayer = (event: any) => {
      if (event.data.name === 'ENTER_FULLSCREEN') {
        setShowFullScreen(true);
      }

      if (event.data === 'status:close') {
        Props.playVideo(false);
        window.removeEventListener('message', closePlayer);
        setShowFullScreen(false);
      }
      if (event.data?.statement?.result?.progress === 100) {
        Props.updateCompaletedStatus && Props?.updateCompaletedStatus();
      }
    };
    window.addEventListener('message', closePlayer);
    return () => {
      window.removeEventListener('message', closePlayer);
    };
  }, [cid]);

  return (
    <div
      key={`course-player-${Props.cid}`}
      className={
        fullScreen || showFullScreen ? 'course-player-on-screen' : 'course-player-container'
      }
    >
      <div className="course-player-wrapper">
        {pcid && (
          <iframe
            ref={iframeRef}
            id="pplayer_iframe"
            name="pfplayer_frame"
            title="Player"
            className="course-player-iframe"
          />
        )}
      </div>
    </div>
  );
}

